const API_BASE = process.env.REACT_APP_API_URL || '';

async function fetchApi(path) {
  const res = await fetch(`${API_BASE}/api${path}`);
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

async function postApi(path, body, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(`${API_BASE}/api${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `API error: ${res.status}`);
  return data;
}

async function fetchApiAuth(path, token) {
  const res = await fetch(`${API_BASE}/api${path}`, {
    headers: { 'Authorization': `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  return res.json();
}

export const getSettings = () => fetchApi('/settings');
export const getServices = () => fetchApi('/services');
export const getAddons = () => fetchApi('/addons');
export const getGallery = (season) => fetchApi(`/gallery${season ? `?season=${season}` : ''}`);
export const getTestimonials = () => fetchApi('/testimonials');
export const getAvailability = (date) => fetchApi(`/availability?date=${date}`);
export const submitContact = (data) => postApi('/contact', data);
export const checkout = (data, token) => postApi('/bookings/checkout', data, token);

// Customer auth
export const registerCustomer = (data) => postApi('/auth/register', data);
export const loginCustomer = (data) => postApi('/auth/login', data);
export const getMe = (token) => fetchApiAuth('/auth/me', token);
export const getMyBookings = (token) => fetchApiAuth('/customer/bookings', token);
export const cancelBooking = (id, token) => postApi(`/customer/bookings/${id}/cancel`, {}, token);
